export enum ProductFilterKey {
  LenderNameOrder = 'lenderNameOrder',
  LenderNameDescription = 'lenderNameDescription',
  LendingTypeOrder = 'lendingTypeOrder',
  ProductTypeOrder = 'productTypeOrder',
  ProductDescription = 'productDescription',
  DescriptionOrder = 'descriptionOrder',
  ProductCodeOrder = 'productCodeOrder',
  ProductCode = 'productCode',
  MaxLtvOrder = 'maxLtvOrder',
  AprcOrder = 'aprcOrder',
  InitialPeriodOrder = 'initialPeriodOrder',
  InitialRateOrder = 'initialRateOrder',
  RevertRateOrder = 'revertRateOrder',
  CashbackOrder = 'cashbackOrder',
  FeesOrder = 'feesOrder',
  InitialMonthlyPaymentOrder = 'initialMonthlyPaymentOrder',
  MonthlyPaymentRevertOrder = 'monthlyPaymentRevertOrder',
  TrueCostTermOrder = 'trueCostTermOrder',
  ErcOrder = 'ercOrder',
}
